var map = {
	"./ArConnect.png": "affa",
	"./BitKeep.png": "edcb",
	"./Coinbase Wallet.png": "4d33",
	"./Finnie.svg": "df99",
	"./Huobi Wallet.png": "06dd",
	"./MathWallet.png": "ce9a",
	"./MetaMask.png": "cb8a",
	"./Safeheron.png": "233a",
	"./Wallet Connect.png": "4c81",
	"./imToken.png": "ff95"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4bc5";